// © 2024–2026 Jos Jozef Sytze van der Werf — Alle rechten voorbehouden.
/**
 * Demo-configuratie voor WilsApp pilotversie.
 *
 * DEMO_MODE = true:
 *   - Profielwachtwoord wordt altijd DEMO_PASSWORD ('2022!')
 *   - Wachtwoordgenerator is zichtbaar als demo maar overschrijft encryptie niet
 *   - LoginPage toont hulptekst
 *
 * DEMO_MODE = false:
 *   - Volledige veilige wachtwoordlogica actief
 *   - Geen hulpteksten
 */
export const DEMO_MODE     = true
export const DEMO_PASSWORD = '2022!'
